import { render, staticRenderFns } from "./ValorantAccountSwitchPopup.vue?vue&type=template&id=020245f8&scoped=true"
import script from "./ValorantAccountSwitchPopup.vue?vue&type=script&lang=js"
export * from "./ValorantAccountSwitchPopup.vue?vue&type=script&lang=js"
import style0 from "./ValorantAccountSwitchPopup.vue?vue&type=style&index=0&id=020245f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020245f8",
  null
  
)

export default component.exports